/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PartnerBusinessActivityStatus;

(function (PartnerBusinessActivityStatus) {
  PartnerBusinessActivityStatus["ACCEPT"] = "accept";
  PartnerBusinessActivityStatus["HIDDEN"] = "hidden";
})(PartnerBusinessActivityStatus || (PartnerBusinessActivityStatus = {}));